import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { combineEpics, ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, debounceTime, map, startWith, switchMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import State from 'src/application/core/State';
import OrderProductsReceived from '../events/OrderProductsReceived';
import OrdersFilterSelected from '../../order/events/OrdersFilterSelected';
import OrdersFilterRemoved from '../../order/events/OrdersFilterRemoved';
import OrderProductsSearchRequested from '../../order/events/OrderProductsSearchRequested';
import OrderPageEntered from '../events/OrderPageEntered';
import OrderPlaceSucceed from '../../order/events/OrderPlaceSucceed';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import productQueryFactory from './productQueryFactory';
import OrderProductsGetRequested from '../events/OrderProductsGetRequested';
import OrderProductsGetFailed from '../events/OrderProductsGetFailed';
import RequestFailed from '../../core/events/RequestFailed';
import { getOrderCurrentCursor } from '../selector';
import OrderProductsNextRequested from '../events/OrderProductsNextRequested';
import OrderProductsPrevRequested from '../events/OrderProductsPrevRequested';

const immediately = (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(
            OrderPageEntered.type,
            OrderPlaceSucceed.type,
            OrdersFilterSelected.type,
            OrdersFilterRemoved.type,
            OrderProductsNextRequested.type,
            OrderProductsPrevRequested.type
        ),
        switchMap((event: Event) => getProducts(event, state$, backend))
    );

const withDelay = (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(OrderProductsSearchRequested.type),
        debounceTime(500),
        switchMap((event: Event) => getProducts(event, state$, backend))
    );

const getProducts = (event: Event, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> => {
    let url = `${api()}products${productQueryFactory('Order', state$.value.order.searchQuery, [
        ...state$.value.order.orderFilters
    ])}&limit=100`;
    if (getOrderCurrentCursor(state$.value.products)) {
        url += '&cursor=' + getOrderCurrentCursor(state$.value.products);
    }
    return backend.get(url).pipe(
        map((ajaxResponse: AjaxResponse) => new OrderProductsReceived(ajaxResponse.response)),
        catchError((e: AjaxError) => of(new OrderProductsGetFailed(), new RequestFailed(e.status))),
        startWith(new OrderProductsGetRequested())
    );
};

export default combineEpics(immediately, withDelay);



// WEBPACK FOOTER //
// ./src/application/products/epic/getOrderProducts.ts